<div class="dtl-modal overflow-hidden rounded-[28px] bg-slate-950 text-slate-100" [attr.data-theme]="themeMode">
  <div class="border-b border-slate-800 bg-slate-900/95 px-6 py-5">
    <div class="flex flex-col gap-4 lg:flex-row lg:items-start lg:justify-between">
      <div class="min-w-0">
        <div class="flex items-center gap-3">
          <span class="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-sky-500/10 text-sky-400">
            <i class="fa-solid fa-truck-ramp-box"></i>
          </span>
          <div>
            <h2 mat-dialog-title class="m-0 text-2xl font-black text-[var(--dtl-text-main)]">{{ modalTitle }}</h2>
          </div>
        </div>
      </div>

      <div class="flex flex-wrap items-center gap-2">
        <button
          type="button"
          class="rounded-full border px-4 py-2 text-sm font-bold transition"
          [class.border-sky-400]="!isSpencerMode"
          [class.bg-sky-500]="!isSpencerMode"
          [class.text-white]="!isSpencerMode"
          [class.border-slate-700]="isSpencerMode"
          [class.text-slate-300]="isSpencerMode"
          (click)="setMode('spirit_kitting')"
        >
          Manual
        </button>
        <button
          type="button"
          class="rounded-full border px-4 py-2 text-sm font-bold transition"
          [class.border-sky-400]="isSpencerMode"
          [class.bg-sky-500]="isSpencerMode"
          [class.text-white]="isSpencerMode"
          [class.border-slate-700]="!isSpencerMode"
          [class.text-slate-300]="!isSpencerMode"
          (click)="setMode('spencer_drop_trailer')"
        >
          ASN
        </button>
        <button type="button" class="inline-flex h-10 w-10 items-center justify-center rounded-full border border-slate-700 text-slate-300 transition hover:bg-slate-800" (click)="close()">
          <i class="fa-solid fa-xmark"></i>
        </button>
      </div>
    </div>
  </div>

  <mat-dialog-content class="dtl-dialog-content">
    <form [formGroup]="form" class="space-y-5">
      <section *ngIf="isSpencerMode" class="rounded-3xl border border-slate-800 bg-slate-900/70 p-5 shadow-sm">
        <div class="mb-4 flex flex-col gap-3 lg:flex-row lg:items-end">
          <mat-form-field appearance="outline" class="w-full lg:w-48">
            <mat-label>Lookup By</mat-label>
            <mat-select formControlName="lookupType">
              <mat-option value="asn_number">ASN</mat-option>
              <mat-option value="trip_number">Trip</mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full flex-1">
            <mat-label>ASN / Trip Number</mat-label>
            <input matInput formControlName="lookupValue" autocomplete="off">
          </mat-form-field>

          <button
            type="button"
            class="mb-[1.35rem] inline-flex min-h-[3.35rem] items-center justify-center gap-2 rounded-2xl bg-sky-500 px-5 text-sm font-bold text-white shadow-lg shadow-sky-950/30 transition hover:bg-sky-400 disabled:opacity-60"
            [disabled]="lookingUpTrip"
            (click)="lookupTrip()"
          >
            <i class="fa-solid fa-magnifying-glass"></i>
            {{ lookingUpTrip ? 'Searching...' : 'Find ASN' }}
          </button>
        </div>

        <div *ngIf="lookupMessage" class="rounded-2xl border border-amber-500/20 bg-amber-500/10 px-4 py-3 text-sm font-semibold text-amber-200">
          {{ lookupMessage }}
        </div>

        <div *ngIf="tripMatches.length > 1" class="grid gap-3 md:grid-cols-2">
          <button
            type="button"
            *ngFor="let trip of tripMatches"
            class="rounded-2xl border border-slate-700 bg-slate-950/60 p-4 text-left transition hover:border-sky-400 hover:bg-slate-900"
            (click)="applyTrip(trip)"
          >
            <div class="flex items-start justify-between gap-3">
              <div>
                <div class="text-sm font-black text-[var(--dtl-text-main)]">{{ trip.asn_number || trip.trip_number }}</div>
                <div class="mt-1 text-xs font-semibold text-slate-400">{{ trip.pool_point_client_name || 'Client not set' }}</div>
              </div>
              <span class="rounded-full bg-slate-800 px-2 py-1 text-[11px] font-bold text-slate-300">{{ trip.shipment_count || 0 }} shipments</span>
            </div>
          </button>
        </div>
      </section>

      <section class="grid gap-4 xl:grid-cols-2">
        <article class="rounded-3xl border border-slate-800 bg-slate-900/70 p-5 shadow-sm">
          <div class="mb-4 flex items-center gap-3">
            <span class="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-emerald-500/10 text-emerald-400">
              <i class="fa-solid fa-user-tie"></i>
            </span>
            <div>
              <h3 class="m-0 text-base font-black text-[var(--dtl-text-main)]">Customer</h3>
              <p class="m-0 text-xs font-semibold text-slate-400">Optional client context</p>
            </div>
          </div>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Customer</mat-label>
            <mat-select formControlName="poolPointClientContactUuid" (selectionChange)="onPoolPointClientChange()">
              <mat-option *ngFor="let client of distinctPoolPointClients" [value]="client.pool_point_client_contact_uuid">
                {{ client.contact_organization || client.pool_point_client_name }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field *ngIf="selectedPoolPointClientIdOptions.length" appearance="outline" class="w-full">
            <mat-label>Client ID</mat-label>
            <mat-select formControlName="poolPointClientUuid" (selectionChange)="onPoolPointClientIdChange()">
              <mat-option value="">None</mat-option>
              <mat-option *ngFor="let client of selectedPoolPointClientIdOptions" [value]="client.pool_point_client_uuid">
                {{ client.pool_point_client_id }}
                <span *ngIf="client.pool_point_client_scope"> - {{ client.pool_point_client_scope }}</span>
                <span *ngIf="client.pool_point_name"> - {{ client.pool_point_name }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="rounded-2xl border border-slate-800 bg-slate-950/50 px-4 py-3 text-sm text-slate-300">
            <div class="flex items-center justify-between gap-3">
              <span>
                {{ selectedPoolPointClientContact?.contact_organization || selectedPoolPointClient?.contact_organization || selectedPoolPointClient?.pool_point_client_name || 'No customer selected' }}
                <span *ngIf="selectedPoolPointClient?.pool_point_client_id" class="text-slate-500"> | {{ selectedPoolPointClient?.pool_point_client_id }}</span>
              </span>
              <button
                type="button"
                class="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-slate-700 text-slate-300 transition hover:bg-slate-800 disabled:opacity-40"
                [disabled]="!selectedPoolPointClientContact && !selectedPoolPointClient"
                (click)="clearPoolPointClientSelection()"
                aria-label="Clear customer"
                title="Clear customer"
              >
                <i class="fa-solid fa-xmark"></i>
              </button>
            </div>
          </div>
        </article>

        <article class="rounded-3xl border border-slate-800 bg-slate-900/70 p-5 shadow-sm">
          <div class="mb-4 flex items-center gap-3">
            <span class="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-sky-500/10 text-sky-400">
              <i class="fa-solid fa-warehouse"></i>
            </span>
            <div>
              <h3 class="m-0 text-base font-black text-[var(--dtl-text-main)]">Distribution Center</h3>
              <p class="m-0 text-xs font-semibold text-slate-400">Shipper</p>
            </div>
          </div>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Distribution Center</mat-label>
            <mat-select formControlName="distributionCenterUuid" [disabled]="loadingDistributionCenters || (!distributionCenters.length && !selectedDistributionCenter)">
              <mat-option *ngFor="let center of distributionCenters" [value]="center.customer_contact_distribution_center_uuid">
                {{ center.distribution_center_reference || center.contact_organization }}
                <span *ngIf="center.contact_organization"> - {{ center.contact_organization }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="rounded-2xl border border-slate-800 bg-slate-950/50 px-4 py-3 text-sm text-slate-300">
            {{ selectedDistributionCenter?.contact_organization || 'No distribution center selected' }}
            <span class="text-slate-500"> | </span>
            {{ displayLocation(selectedDistributionCenter) }}
          </div>
        </article>

        <article class="rounded-3xl border border-slate-800 bg-slate-900/70 p-5 shadow-sm">
          <div class="mb-4 flex items-center gap-3">
            <span class="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-violet-500/10 text-violet-300">
              <i class="fa-solid fa-location-dot"></i>
            </span>
            <div>
              <h3 class="m-0 text-base font-black text-[var(--dtl-text-main)]">Pool Point</h3>
              <p class="m-0 text-xs font-semibold text-slate-400">Consignee</p>
            </div>
          </div>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Pool Point</mat-label>
            <mat-select formControlName="poolPointUuid">
              <mat-option value="">{{ defaultConsigneeName }}</mat-option>
              <mat-option *ngFor="let poolPoint of poolPoints" [value]="poolPoint.pool_point_uuid">
                {{ poolPoint.pool_point_name || poolPoint.contact_organization }}
                <span *ngIf="poolPoint.pool_point_id"> - {{ poolPoint.pool_point_id }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="rounded-2xl border border-slate-800 bg-slate-950/50 px-4 py-3 text-sm text-slate-300">
            {{ selectedPoolPoint?.contact_organization || selectedPoolPoint?.pool_point_name || defaultConsigneeName }}
            <span class="text-slate-500"> | </span>
            {{ selectedPoolPoint ? displayLocation(selectedPoolPoint) : 'Default consignee' }}
          </div>
        </article>

        <article class="rounded-3xl border border-slate-800 bg-slate-900/70 p-5 shadow-sm">
          <div class="mb-4 flex items-center gap-3">
            <span class="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-amber-500/10 text-amber-300">
              <i class="fa-solid fa-truck-fast"></i>
            </span>
            <div>
              <h3 class="m-0 text-base font-black text-[var(--dtl-text-main)]">Carrier</h3>
              <p class="m-0 text-xs font-semibold text-slate-400">Assigned carrier</p>
            </div>
          </div>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Carrier</mat-label>
            <mat-select formControlName="carrierContactUuid">
              <mat-option *ngFor="let carrier of carriers" [value]="carrier.carrier_contact_uuid">
                {{ carrier.carrier_name }}
                <span *ngIf="carrier.contact_scac"> - {{ carrier.contact_scac }}</span>
              </mat-option>
            </mat-select>
          </mat-form-field>

          <div class="rounded-2xl border border-slate-800 bg-slate-950/50 px-4 py-3 text-sm text-slate-300">
            {{ selectedCarrier?.carrier_name || 'No carrier selected' }}
          </div>
        </article>
      </section>

      <section class="rounded-3xl border border-slate-800 bg-slate-900/70 p-5 shadow-sm">
        <div class="mb-4 flex items-center gap-3">
          <span class="inline-flex h-9 w-9 items-center justify-center rounded-2xl bg-cyan-500/10 text-cyan-300">
            <i class="fa-solid fa-file-invoice"></i>
          </span>
          <h3 class="m-0 text-base font-black text-[var(--dtl-text-main)]">Lading Details</h3>
        </div>

        <div class="grid gap-4 md:grid-cols-2 xl:grid-cols-4">
          <mat-form-field appearance="outline" class="w-full md:col-span-2 xl:col-span-2">
            <mat-label>Lading Number</mat-label>
            <input matInput formControlName="ladingNumber" autocomplete="off">
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Carrier Trailer</mat-label>
            <input matInput formControlName="carrierTrailer" autocomplete="off">
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Seal Number</mat-label>
            <input matInput formControlName="sealNumber" autocomplete="off">
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Booking Number</mat-label>
            <input matInput formControlName="bookingNumber" autocomplete="off">
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Shipment Number</mat-label>
            <input matInput formControlName="shipmentNumber" autocomplete="off">
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Pieces</mat-label>
            <input matInput type="number" min="0" formControlName="loadPieces">
          </mat-form-field>

          <mat-form-field appearance="outline" class="w-full">
            <mat-label>Weight</mat-label>
            <input matInput type="number" min="0" formControlName="loadWeight">
          </mat-form-field>
        </div>
      </section>
    </form>
  </mat-dialog-content>

  <div class="flex flex-col-reverse gap-3 border-t border-slate-800 bg-slate-900/95 px-6 py-4 sm:flex-row sm:items-center sm:justify-end">
    <button type="button" class="inline-flex min-h-11 items-center justify-center rounded-2xl border border-slate-700 px-5 text-sm font-bold text-slate-300 transition hover:bg-slate-800" (click)="close()" [disabled]="submitting">
      Cancel
    </button>
    <button type="button" class="inline-flex min-h-11 items-center justify-center gap-2 rounded-2xl bg-emerald-500 px-5 text-sm font-bold text-white shadow-lg shadow-emerald-950/30 transition hover:bg-emerald-400 disabled:opacity-60" (click)="submit()" [disabled]="submitting || loadingLookups">
      <i class="fa-solid fa-floppy-disk"></i>
      {{ submitting ? 'Creating...' : 'Create Drop Trailer' }}
    </button>
  </div>
</div>
